import Model from "@@/package/mapper/Model";

export class CourseLearningPositionModel extends Model {
  constructor(
    public courseIdx: number = 0,
    public skillIdx: number = 0,
    public exerciseIdx: number = 0,
    public skillTitle: string = "",
    public skillId: number = 0,
    public taskId: number = 0,
    public courseId: number = 0,
    public trackLevelIdx: number = 0,
    public trackLevelAuthFlag: boolean = false
  ) {
    super();
  }
}
